import { ROUTES } from '@/routes/paths';

export interface SellOfferLinkContext {
  readonly orderId: number;
  /** Контекст группы — для ссылки «назад» к списку офферов культуры на базисе. */
  readonly address: string;
  readonly addressTitle: string;
  readonly goods: string;
  readonly year: number;
}

/** Ссылка на редактирование предложения (/app/sell/edit) — данные грузятся по orderId. */
export function makeSellEditUrl(orderId: number): string {
  return `${ROUTES.APP_SELL_EDIT}?orderId=${orderId}`;
}

/** Ссылка на деталь одного предложения (/app/sell/offer) с контекстом группы для навигации назад. */
export function makeSellOfferUrl(context: SellOfferLinkContext): string {
  const qs = new URLSearchParams({
    orderId: String(context.orderId),
    address: context.address,
    addressTitle: context.addressTitle,
    goods: context.goods,
    year: String(context.year),
  });
  return `${ROUTES.APP_SELL_OFFER}?${qs.toString()}`;
}
